var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReloadLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.827 131.821L186.398 133.554C167.888 181.286 114.188 204.975 66.4563 186.465C40.3304 176.334 20.1898 154.928 11.6664 128.235C11.1298 126.552 9.33101 125.624 7.64847 126.16C5.96592 126.697 5.03735 128.496 5.57396 130.178C22.2284 182.309 77.9896 211.068 130.12 194.413C158.789 185.254 181.742 163.562 192.504 135.455L198.577 137.338L199.999 101.49L180.827 131.821Z",
    fill: "#212842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.585 66.479C32.0858 18.7433 85.7809 -4.95655 133.517 13.5442C159.88 23.7617 180.138 45.4518 188.534 72.45C188.953 73.7829 190.19 74.6891 191.587 74.6875C191.912 74.6875 192.235 74.6392 192.546 74.5437C194.232 74.0195 195.173 72.2282 194.65 70.5425C194.65 70.5421 194.65 70.5421 194.649 70.5417C178.393 18.2858 122.852 -10.8976 70.5961 5.35926C41.5933 14.3817 18.3306 36.2076 7.47974 64.5771L1.42243 62.6944L0 98.5428L19.1565 68.2115L13.585 66.479Z",
    fill: "#212842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReloadLg);
export default __webpack_public_path__ + "static/media/icon-reload-lg.846f6d17.svg";
export { ForwardRef as ReactComponent };